import { useEffect, useState } from "react";

export const useFilterState = (filter: string): [string, (v: string) => void] => {
  const [filterState, setFilter] = useState(filter);

  useEffect(() => {
    if (filterState !== filter) {
      setFilter(filter);
    }
  }, [filter]);

  return [filterState, setFilter];
};
